import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import FetchRecurringSubscriptionExist from '@/plugins/graphql/queries/v2/ecommerce/fetch-recurring-subscription-exist.gql';
let Redirector = class Redirector extends Mixins(RouterParamsAppMixin, AlertMixin) {
    get redirectMessage() {
        return this.message;
    }
    mounted() {
        const redirectUrl = sessionStorage.getItem('redirectUrl');
        if (redirectUrl === 'saved-payment-methods') {
            this.performRedirect('saved-payment-methods');
        }
        else {
            setTimeout(() => {
                this.checkSubscription(redirectUrl);
            }, 3000);
        }
    }
    async checkSubscription(redirectUrl) {
        const { data } = await this.$apollo.query({
            query: FetchRecurringSubscriptionExist,
            variables: { appUuid: this.appUUID },
        });
        if (data.fetchCustomerDetails?.isSubscribed) {
            this.successNotification('Recurring subscription successfully activated!');
        }
        else {
            this.errorNotification('Recurring subscription activation failed!');
        }
        setTimeout(() => {
            this.performRedirect(redirectUrl || '');
        }, 3000);
    }
    performRedirect(redirectUrl) {
        try {
            // Check if the redirectUrl is not null and not empty
            // If the redirectUrl is not null and not empty, then redirect to the redirectUrl
            if (redirectUrl) {
                sessionStorage.removeItem('redirectUrl');
                this.$router.push({ name: redirectUrl });
                return;
            }
            this.$router.push('/404');
        }
        catch (error) {
            console.error('Redirection Error:', error);
            this.$router.push('/404');
        }
    }
};
__decorate([
    Prop({ type: String, default: 'Redirecting...' })
], Redirector.prototype, "message", void 0);
Redirector = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
        },
    })
], Redirector);
export default Redirector;
